module.exports = __webpack_public_path__ + "static/media/global-preloader.8f765de3.gif";